import React from "react";
import parse from "html-react-parser";
import { MaterialDialog } from "../../material-lib/material-components/MaterialDialog";
import { saveNairaDisclaimer } from "../services/nairaService";

export const NairaTermsOfService = ({ open, setOpen, openChat, disclaimerJson }) => {
  const onAcceptNairaTerms = async () => {
    try {
      await saveNairaDisclaimer(disclaimerJson?.data?.[0]?.Version);
      setOpen(false);
      openChat();
    } catch (error) {
      console.error("Error saving disclaimer");
    }
  };

  const onCloseOrOnRejectNairaTerms = () => {
    setOpen(false);
  };

  return (
    <MaterialDialog
      open={open}
      onAccept={onAcceptNairaTerms}
      onClose={onCloseOrOnRejectNairaTerms}
      onReject={onCloseOrOnRejectNairaTerms}
      title="NaiRA Disclaimer"
      body={parse(disclaimerJson?.data?.[0]?.content ?? "")}
      closeIcon={true}
      data-testid="naira-terms"
    />
  );
};
